// extracted by mini-css-extract-plugin
export var filterIncDec = "_e6-0";
export var leftBorder = "_e6-1";
export var rightBorder = "_e6-2";
export var stringInput = "_e6-3";